export type UploadAbortReason = 'stall' | 'user';

export class UploadStallWatchdog {
  #timer: ReturnType<typeof setTimeout> | undefined;
  #lastLoaded = 0;
  #abortedForStall = false;

  constructor(
    private readonly timeoutMs: number,
    private readonly onStall: () => void,
  ) {}

  start() {
    this.#resetStallTimeout();
  }

  recordProgress(loaded: number) {
    if (loaded > this.#lastLoaded) {
      this.#lastLoaded = loaded;
      this.#resetStallTimeout();
    }
  }

  dispose() {
    if (this.#timer !== undefined) {
      clearTimeout(this.#timer);
      this.#timer = undefined;
    }
  }

  getAbortReason(): UploadAbortReason {
    return this.#abortedForStall ? 'stall' : 'user';
  }

  #resetStallTimeout() {
    this.dispose();
    this.#timer = setTimeout(() => {
      this.#abortedForStall = true;
      this.onStall();
    }, this.timeoutMs);
  }
}
